import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { SignatureCabinet } from '@/features/reglages/emails-panel';

export const Route = createFileRoute('/_app/settings/signatures')({
  component: SignaturesSettings,
});

function SignaturesSettings() {
  const navigate = useNavigate();
  return <SignatureCabinet onDemanderLogo={() => void navigate({ to: '/settings/practice' })} />;
}
